import { useState } from "react";
import play from "../../assests/play2.svg";
import SingleVideoPlayer from "../SingleVideoPlayer/SingleVideoPlayer";

function ReferenceVideoPlayer({ performanceData }) {
  const [showVideo, setShowVideo] = useState(false);
  return (
    <>
      <div
        className=" w-full max-w-[280px] bg-[#000] rounded-[15px] flex items-center justify-between  mx-auto cursor-pointer"
        onClick={() => setShowVideo(true)}
      >
        <div className="flex items-center gap-[10px] overflow-hidden w-full">
          <div className="h-[53px] w-[25%] overflow-hidden rounded-l-[15px] relative">
            <img src={performanceData?.thumbnailUrl} alt="" className="object-fill w-full h-full"/>
          </div>
          <p className="text-[14px] text_1Line">{performanceData?.fileName}</p>
        </div>
        <div className="h-[30px] w-[30px] shrink-0 mr-[12px] ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="33"
            viewBox="0 0 33 33"
            fill="none"
            className="w-full h-full"
          >
            <circle cx="16.5" cy="16.5" r="16.5" fill="#606060" />
            <path d="M13 8L23 16.5029L13 25V8Z" fill="#EAF0FF" />
          </svg>
        </div>
      </div>

      {showVideo && (
        <SingleVideoPlayer
          setHowToParticipatePopup={setShowVideo}
          fileUrl={performanceData?.fileUrl}
          heading={performanceData?.fileName}
        />
      )}
    </>
  );
}

export default ReferenceVideoPlayer;
